import React from "react";
import { useEffect, useState } from "react";
import styles from "../styles.modules.scss";

export function Timer({
    timerString,
    lang,
}: {
    timerString: string;
    lang: string;
}) {
    const [remainingTime, setRemainingTime] = useState<{
        remainingSeconds: number | null;
        remainingHours: number;
        remainderMinutes: number;
    }>({
        remainingSeconds: null,
        remainingHours: 0,
        remainderMinutes: 0,
    });

    const endTime = timerString ? new Date(timerString).getTime() : 0;

    useEffect(() => {
        const timer = async () => {
            const timeData = {
                secondsLeft: Math.floor((endTime - Date.now()) / 1000),
                secondsLeftTimestampMs:
                    Date.now() +
                    Math.floor((endTime - Date.now()) / 1000) * 1000,
            };

            const remainingSeconds = timeData.secondsLeft;

            let remainingHours = Math.floor(remainingSeconds / 3600);

            const remainderSeconds = remainingSeconds - remainingHours * 3600;

            let remainderMinutes = Math.ceil(remainderSeconds / 60);

            if (remainderMinutes === 60) {
                remainingHours += 1;
                remainderMinutes = 0;
            }

            setRemainingTime({
                remainingSeconds,
                remainingHours,
                remainderMinutes,
            });
        };
        timer();
        const interval = setInterval(() => {
            timer();
        }, 1000);
        return () => clearInterval(interval);
    }, [endTime]);

    const translate = (id: "hoursAbbreviated" | "minutesAbbreviated") => {
        type Translations = {
            hoursAbbreviated: string;
            minutesAbbreviated: string;
        };

        const translations: {
            [key in string]: Translations;
        } = {
            de: {
                hoursAbbreviated: "H",
                minutesAbbreviated: "M",
            },
            en: {
                hoursAbbreviated: "h",
                minutesAbbreviated: "m",
            },
            es: {
                hoursAbbreviated: "h",
                minutesAbbreviated: "min",
            },
            fr: {
                hoursAbbreviated: "h",
                minutesAbbreviated: "min",
            },
            it: {
                hoursAbbreviated: "h",
                minutesAbbreviated: "m",
            },
            ja: {
                hoursAbbreviated: "時間",
                minutesAbbreviated: "分",
            },
            ko: {
                hoursAbbreviated: "시간",
                minutesAbbreviated: "분",
            },
            pl: {
                hoursAbbreviated: "h",
                minutesAbbreviated: "m",
            },
            pt: {
                hoursAbbreviated: "h",
                minutesAbbreviated: "m",
            },
            ru: {
                hoursAbbreviated: " ч.",
                minutesAbbreviated: " м.",
            },
            tr: {
                hoursAbbreviated: "sa",
                minutesAbbreviated: "dk",
            },
            "zh-hans": {
                hoursAbbreviated: "小时",
                minutesAbbreviated: "分",
            },
            zh: {
                hoursAbbreviated: "小時",
                minutesAbbreviated: "分",
            },
            // Likely unused
            da: {
                hoursAbbreviated: "t",
                minutesAbbreviated: "min",
            },
            ar: {
                hoursAbbreviated: " س",
                minutesAbbreviated: " د",
            },
            fi: {
                hoursAbbreviated: "t",
                minutesAbbreviated: "min",
            },
            id: {
                hoursAbbreviated: "j",
                minutesAbbreviated: "m",
            },
            ms: {
                hoursAbbreviated: "j",
                minutesAbbreviated: "m",
            },
            nl: {
                hoursAbbreviated: "u",
                minutesAbbreviated: "m",
            },
            th: {
                hoursAbbreviated: "ชม.",
                minutesAbbreviated: "น.",
            },
            vi: {
                hoursAbbreviated: "giờ",
                minutesAbbreviated: "ph",
            },
        };

        return translations[lang]?.[id] || translations["en"]?.[id];
    };

    return (
        <div
            className={`maintenanceTimeContainer ${styles.maintenanceTimeContainer}`}
        >
            <MaintenanceClock />
            <div className={`maintenanceTimeBox ${styles.maintenanceTimeBox}`}>
                <div
                    className={`maintenanceEstimatedNumberText ${styles.maintenanceEstimatedNumberText}`}
                >
                    {remainingTime.remainingSeconds !== null ? (
                        remainingTime.remainingSeconds > 0 ? (
                            <>
                                {remainingTime.remainingHours}
                                {translate("hoursAbbreviated")}{" "}
                                {remainingTime.remainderMinutes}
                                {translate("minutesAbbreviated")}
                            </>
                        ) : (
                            `0${translate("hoursAbbreviated")} 0${translate("minutesAbbreviated")}`
                        )
                    ) : (
                        "..."
                    )}
                </div>
            </div>
        </div>
    );
}

function MaintenanceClock() {
    const [rotation, setRotation] = useState(90);

    useEffect(() => {
        const interval = setInterval(() => {
            setRotation((prevRotation) => {
                return prevRotation + 90;
            });
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className={`maintenanceClock ${styles.maintenanceClock}`}>
            <div
                className={`maintenanceClockPointer ${styles.maintenanceClockPointer}`}
                style={{ transform: `rotate(${rotation}deg)` }}
            ></div>
        </div>
    );
}
